export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-04-07 at 11.31.16 PM.6195a910.jpeg";